import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id CA6D7ED5-38E6-4B63-915A-431CDDA27062
 * name briefcase-plus-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/briefcase-plus-outline.svg
 * tags
 */
export const BriefcasePlusOutlineIcon = createSvgIcon(<><path d="M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V13.53C21.42,13 20.75,12.6 20,12.34V8H4V19H12.08C12.2,19.72 12.45,20.39 12.8,21H4A2,2 0 0,1 2,19V8A2,2 0 0,1 4,6H8V4A2,2 0 0,1 10,2M14,6V4H10V6H14M14,17H17V14H19V17H22V19H19V22H17V19H14V17Z" /></>, 'BriefcasePlusOutlineIcon');
export default BriefcasePlusOutlineIcon